export const boundsForPoints = points => {
  const noNullPoints = points.filter(point => point != null);

  const simpleBounds = {
    left: Math.min.apply(
      null,
      noNullPoints.map(({ dx }) => dx)
    ),
    right: Math.max.apply(
      null,
      noNullPoints.map(({ dx }) => dx)
    ),
    top: Math.min.apply(
      null,
      noNullPoints.map(({ dy }) => dy)
    ),
    bottom: Math.max.apply(
      null,
      noNullPoints.map(({ dy }) => dy)
    ),
  };

  const size = {
    width: simpleBounds.right - simpleBounds.left,
    height: simpleBounds.bottom - simpleBounds.top,
  };

  return {
    ...simpleBounds,
    ...size,
    centerX: simpleBounds.left + size.width * 0.5,
    centerY: simpleBounds.top + size.height * 0.5,
  };
};

export const getDistance = (drawingCoord, boxCoord) => {
  const xDistance = Math.abs(boxCoord.centX - drawingCoord.centX);
  const yDistance = Math.abs(boxCoord.centY - drawingCoord.centY);

  return Math.hypot(xDistance, yDistance);
};

export const closestBox = (drawingCoord, boxObj) => {
  let minDistance = Infinity;
  let closestBox;
  const arrayOfBoxes = Object.values(boxObj);
  for (let i = 0; i < arrayOfBoxes.length; i++) {
    const box = arrayOfBoxes[i];
    const boxCenterCoord = { centX: box.left + box.width / 2, centY: box.top + box.height / 2 };

    if (getDistance(drawingCoord, boxCenterCoord) < minDistance) {
      minDistance = getDistance(drawingCoord, boxCenterCoord);
      closestBox = box;
    }
  }
  return closestBox;
};

export const getClientPointsFromOffset = (arr, { x, y }) => {
  return arr.map(point => {
    if (!point) {
      return null;
    } else {
      return {
        ...point,
        dx: point.dx + x,
        dy: point.dy + y,
      };
    }
  });
};
